/* eslint-disable prettier/prettier */
import Vue from "vue";
// import  * as error from "./utils/error.js"
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import ErrorPlugin from "./js/errorPlugin";
// Vue.use(ErrorPlugin);
import "ant-design-vue/dist/antd.css";
// import "./js/map/registerServiceWorker";
import Antd from "ant-design-vue";
Vue.config.productionTip = false;

Vue.use(Antd);

import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9,
    title: false, //	显示当前图片的标题
    scalable: false, //图片是否可翻转
    rotatable: true, //图片是否可旋转
    tooltip: false, //显示缩放百分比
    navbar: false, //显示缩略图导航
    loop: false,
    loading: false
  }
});

import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");

import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";

Vue.use(VXETable);
// 省市区
import "vue-area-linkage/dist/index.css"; // v2 or higher
import VueAreaLinkage from "vue-area-linkage";
Vue.use(VueAreaLinkage);

import Authorized from "./components/Authorized";
import Auth from "./directives/auth";
Vue.use(Auth);
Vue.component("Authorized", Authorized);


// 拾色器
// import vcolorpicker from 'vcolorpicker'
// Vue.use(vcolorpicker)
// 打印
// import Print from './js/map/print'
// Vue.use(Print) // 
// 引入echarts
// import 'default-passive-events'
// import echarts from "echarts";
// Vue.prototype.$echarts = echarts;

import "default-passive-events"; //添加事件管理者'passive'，来阻止'touchstart'事件，让页面更加流畅。


new Vue({
  // error,
  router,
  store,
  render: function(h) {
    return h(App);
  }
}).$mount("#app");
